export default __webpack_public_path__ + "static/media/UbuntuMono-R.9eecd081.ttf";